export default "__VITE_ASSET__Cv8OXu8w__"